import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { AttendanceApiError } from 'src/services/lmsAttendanceService';

type Props = {
  fileName: string;
  error: AttendanceApiError | null;
  onClose: () => void;
};

const ImportErrorDialog = ({ fileName, error, onClose }: Props) => (
  <Dialog open={Boolean(error)} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ErrorOutlineIcon color="error" />
      Import failed
    </DialogTitle>
    {error && (
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          File: <strong>{fileName}</strong>
          {error.statusCode ? ` · Status ${error.statusCode}` : ''}
        </Typography>
        <Alert severity="error" sx={{ mb: error.errors.length ? 2 : 0 }}>
          {error.message}
        </Alert>
        {error.errors.length > 0 && (
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              {error.errors.length} {error.errors.length === 1 ? 'issue' : 'issues'} found
            </Typography>
            <TableContainer sx={{ maxHeight: 360, border: 1, borderColor: 'divider', borderRadius: 1 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 80 }}>Row</TableCell>
                    <TableCell sx={{ width: 180 }}>Column</TableCell>
                    <TableCell>Message</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {error.errors.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.row ?? '-'}</TableCell>
                      <TableCell>{item.column || '-'}</TableCell>
                      <TableCell>{item.message || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </DialogContent>
    )}
    <DialogActions sx={{ px: 3, py: 2 }}>
      <Button variant="contained" onClick={onClose}>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ImportErrorDialog;
